import { createSelector } from "reselect";

import { EMPTY_ARRAY, EMPTY_OBJECT } from "lib";

import { getEmails, getReportJobs, getBusinesses } from "../root";

interface ReportJobWithEmails extends ReportJob {
  emails: Email[];
}
export interface ReportJobAggridData {
  reportJob: ReportJobWithEmails;
  business: Business | object;
}

export const selectReportJobAggridData = createSelector(
  [getReportJobs, getEmails, getBusinesses],
  (
    reportJobByIdLookup: Record<string, ReportJob>,
    emailByIdLookup: Record<string, Email>,
    businessByIdLookup: Record<string, Business>,
  ): ReportJobAggridData[] => {
    const data: ReportJobAggridData[] = [];
    for (const reportJob of Object.values(reportJobByIdLookup)) {
      data.push({
        reportJob: {
          ...reportJob,
          emails:
            reportJob.emailIds?.map(id => emailByIdLookup[id]) || EMPTY_ARRAY,
        },
        // References the FIRST business in the document.
        business:
          reportJob.businessIds?.map(id => businessByIdLookup[id])?.[0] ||
          EMPTY_OBJECT,
      });
    }
    return data;
  },
);
